import { CreateIndividualInput } from '@buy-viasat/types/build/bv';
import api, { apiEndpoints } from 'shared/services/axios';

export type CreateIndividualRestResponse = { partyId: string; relnId: string };

export async function createIndividualRest(input: CreateIndividualInput): Promise<CreateIndividualRestResponse> {
  const response = await api.post<CreateIndividualRestResponse>(apiEndpoints.createIndividual, input);
  return response.data;
}
